
import { Form } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { URL_BACKEND } from "../../api/url";
import { elToast } from "../../functions/alertas";
import { formatearFecha } from "../../functions/formatearHora";

export const useEditarAspirante = () => {

    // variables
    const [form] = Form.useForm()

    const { id:pk_aspirante } = useParams()

    // state
    const [isLoading, setIsLoading] = useState(false)
    const [valoresForm, setValoresForm] = useState()
    const [pkCarrera, setPkCarrera] = useState()
    const [bachilleratos, setBachilleratos] = useState([])
    const [pkBachillerato, setPkBachillerato] = useState()
    const [cargando, setCargando] = useState( true )

    // funciones
    const traerDatosAlumno = () => {

        setCargando( true )

        let datos = new FormData()
        datos.append('pk_aspirante', pk_aspirante)
        datos.append('funcion', 'traerDatosAlumno')

        fetch( URL_BACKEND, {
            method: 'post',
            body: datos
        })
        .then( res => res.json() )
        .then( function( d ){

            // console.log( d );
            // hola sujeto del futuro, aquí nomas toy poniendole datos a los inputs
            Object.keys(d).forEach(function(key) {
                // console.log( key );
                // console.log( d[key] );
                if ( key === 'pk_carrera' ) {
                    setPkCarrera( d[ key ] )
                }
                if ( key === 'pk_bachillerato' ) {
                    setPkBachillerato( d[ key ] )
                }

                if (key === 'fecha_alta_universidad') {

                    // form.setFieldsValue({
                        // fecha_alta_universidad: moment(d[key], 'YYYY-MM-DD')
                    // })
                    if ( d[key] === '0000-00-00' ) {
                        setValoresForm({
                            ...valoresForm
                        })
                    } else {
                        setValoresForm({
                            ...valoresForm,
                            fecha_alta_universidad: moment( d[key], 'YYYY-MM-DD')
                        })
                    }

                } else {
                    // form.setFieldsValue({
                    //     [key]: d[key]
                    // })
                    setValoresForm({
                        ...valoresForm,
                        [key]: d[key]
                    })
                }

            });

        })
        .finally(() => setCargando( false ))

    }

    const traerBachilleratos = () => {

        let datos = new FormData()
        datos.append('pk_aspirante', pk_aspirante)
        datos.append('funcion', 'traerBachilleratos')

        fetch( URL_BACKEND, {
            method: 'post',
            body: datos
        })
        .then( res => res.json() )
        .then( function( d ){

            setBachilleratos( d )

        })

    }

    const onFinish = (values) => {

        // setIsLoading(true)

        values.fecha_alta_universidad = formatearFecha( values.fecha_alta_universidad )

        values.funcion = 'actualizarAspirante'
        values.pk_aspirante = pk_aspirante
        values.fk_carrera = pkCarrera
        values.fk_bachillerato = pkBachillerato

        // console.log( values );

        fetch( URL_BACKEND, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(values)
        })
        .then( res => res.json())
        .then( function(d) {
            // console.log(d);

            setIsLoading(false)

            if ( d.codigo === 1 ) {
                elToast( d.mensaje )
            } else {
                elToast( d.mensaje, 'error' )
            }

        })
        // .catch( function(e) {
        //     console.log(e)
        //     setIsLoading(false)
        // })
    };

    // useEffects
    useEffect(() => {
        traerDatosAlumno()
        traerBachilleratos()
        //eslint-disable-next-line
    }, [])

    useEffect(() => {

        form.setFieldsValue( valoresForm )
        //eslint-disable-next-line
    }, [ valoresForm ])

    return {
        onFinish,
        isLoading,
        form,
        valoresForm,
        setPkCarrera,
        bachilleratos,
        setPkBachillerato,
        cargando
    }
}
